// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/project_images/techify.jpg",
    title: "Techify Ecommerce",
    description:
      "Techify is a modern, feature-rich e-commerce platform built on Django, designed to make online shopping easy and enjoyable. Users can browse a well-organized product catalog, add items to their cart, and complete secure checkouts with integrated PayPal payments. From managing orders to tracking history and applying discount coupons, Techify covers every part of the shopping journey. For administrators, the powerful admin panel streamlines product, user, and order management. With features like ratings and reviews, Techify delivers a comprehensive e-commerce experience for users and admins.",
    tech_stack: ["HTML", "CSS", "Bootstrap", "JavaScript", "Python", "Django", "Paypal Integration", "PostgreSQL"],
    github_url: "https://github.com/safu-van/techify",
    demo_url: "",
  },
  {
    img: "/project_images/netflix.png",
    title: "Netflix Lite",
    description:
      "This project is a Netflix-inspired web application that I built using ReactJS as the frontend framework. The primary goal of this project was to enhance my ReactJS skills and learn how to fetch data from a public API, specifically The Movie Database (TMDB) API, to display movies dynamically.",
    tech_stack: ["HTML", "TailwindCSS", "JavaScript", "React", "TMDB API"],
    github_url: "https://github.com/safu-van/netflix-clone",
    demo_url: "https://netflix.techify.fun/",
  },
  {
    img: "/project_images/olx.png",
    title: "OLX Lite",
    description:
      "This project is an OLX-inspired web application that I built using ReactJS as the frontend framework and Firebase as the backend service. The main goal of this project was to enhance my skills in ReactJS and gain a deeper understanding of Firebase for real-time data handling and backend services.",
    tech_stack: ["HTML", "TailwindCSS", "JavaScript", "React", "Firebase"],
    github_url: "https://github.com/safu-van/olx-clone",
    demo_url: "https://olx.techify.fun/",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    name: "ReactJS",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redux/redux-original.svg",
    name: "Redux",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/firebase/firebase-plain.svg",
    name: "Firebase",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "MongoDB",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    name: "Python",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/django/django-plain.svg",
    name: "Django",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    name: "C",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
    name: "MySQL",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-original.svg",
    name: "Bootstrap",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/materialui/materialui-original.svg",
    name: "Material UI",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg",
    name: "Figma",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg",
    name: "TailwindCSS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
    name: "VS Code",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg",
    name: "PostgreSQL",
  },
  {
    img: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
    name: "AWS",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/postman/postman-original.svg",
    name: "Postman",
  },
];
